'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TruncateComponent } from "./component";
import { TruncatePipe } from "./pipe";
import { LKTooltip } from "../tooltip/module";

@NgModule({
  imports     : [
    BrowserModule,
    LKTooltip
  ],
  declarations: [TruncateComponent, TruncatePipe],
  exports     : [TruncateComponent]
})
export class LKTruncation {
}
